import { stringifyValue } from "../../utils";

/** A field's value as the card shows it. Data is never recased. */
export function formatFieldValue(value: unknown): string {
  if (value === true) return "Checked";
  if (value === false) return "Unchecked";
  return stringifyValue(value);
}
